import Counter from "@/ui/core/Counter";
import Icon from "@/ui/core/Icon/Icon";
import { FAIconName } from "@/ui/core/Icon/IconDefinitions";
import Text from "@/ui/core/Text";
import { HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface TabButtonProps extends BaseViewProps {
  badgeCount?: number;
  icon?: FAIconName;
  isActive?: boolean;
  isDropdown?: boolean;
  onPress: () => void;
  title: string;
}

const TabButton = ({
  accessibilityLabel,
  badgeCount,
  icon,
  isActive,
  isDropdown,
  onPress,
  testID,
  title,
}: TabButtonProps) => {
  const textColor = isActive
    ? ColorToken.AccentBlue
    : ColorToken.Primary90Variant;
  const bgColor = isActive ? ColorToken.Secondary10 : ColorToken.Transparent;

  const baseTestID = joinTestIDs(testID, "tab-button");

  return (
    <HStack
      alignItems="center"
      animateOnly={["backgroundColor"]}
      aria-label={accessibilityLabel}
      aria-selected={isActive}
      backgroundColor={bgColor}
      borderRadius={12}
      cursor="pointer"
      gap={isDropdown ? 6 : 8}
      justifyContent="center"
      onPress={onPress}
      paddingHorizontal={isDropdown ? 16 : 12}
      paddingVertical={8}
      pressStyle={{ backgroundColor: ColorToken.Secondary5 }}
      role="tab"
      testID={baseTestID}
      transition="fade"
    >
      {icon && (
        <Icon
          color={textColor}
          name={icon}
          size="sm"
          testID={joinTestIDs(baseTestID, "icon")}
        />
      )}
      <Text
        color={textColor}
        testID={joinTestIDs(baseTestID, "title")}
        variant="bodyMedium"
      >
        {title}
      </Text>
      <Counter isActive={isActive} number={badgeCount} testID={baseTestID} />
      {isDropdown && (
        <Icon
          color={ColorToken.AccentBlue}
          name={FAIconName.ChevronDown}
          size="sm"
          testID={testID}
        />
      )}
    </HStack>
  );
};

export type { TabButtonProps };
export default TabButton;
